<template>
  <div style="display: flex;">
    <SjDrawer style="height: 600px;flex-shrink: 0" :initValue="200">
      <div style="background: yellow;height: 100%">
        test
      </div>
    </SjDrawer>
    <div
      class="center"
      style="flex-grow: 1;display: flex;flex-direction: column;align-items: stretch"
    >
      <SjDrawer style="flex-shrink: 0" direction="top" :initValue="200">
        <div style="background: green;height: 100%">
          test top
        </div>
      </SjDrawer>
      <div style="flex-grow: 1;"></div>
      <SjDrawer style="flex-shrink: 0" direction="bottom" :initValue="300">
        <div style="background: green;height: 100%">
          test bottom
        </div>
      </SjDrawer>
    </div>
    <SjDrawer
      style="height: 600px;flex-shrink: 0"
      direction="right"
      :initValue="300"
    >
      <div style="background: yellow;height: 100%">
        test right
      </div>
    </SjDrawer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang="less"></style>
